import groupBy from 'lodash/groupBy'

const groupEntitiesBy = (collection, key) => groupBy(collection, key)

const groupEntitiesByWeek = (collection) => groupBy(collection, 'happenedOnWeek')

const groupEntitiesByImportance = (collection) => groupBy(collection, 'importance')

export { groupEntitiesBy, groupEntitiesByWeek, groupEntitiesByImportance }
